import React from 'react'

const BulletSeparator = () => {
  return <span style={{ marginLeft: 5, marginRight: 5 }}>&bull;</span>
}

export default BulletSeparator